import { GET_STUDENT } from '../constants';

const initialState = {
    studentHistory: null,
    playtime: null
}

const student = (state = initialState, action) => {
    switch (action.type) {
        case GET_STUDENT:
            return {
                ...state,
                studentHistory: action.studentHistory,
                playtime: action.playTime
            }
    
        default:
        return state;
    }
}

export default student;